import { type FC, type PropsWithChildren, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { SpecContractBg } from '@/components/Contract/SpecContractBg/SpecContractBg';
import { H1 } from '@/components/Typography/Typography';
import { Close } from '@/components/ui/Close/Close';

import { ModalContext } from '../../Modal/config';

import { titles } from './config';

interface SpecContractWrapperProps extends PropsWithChildren {
  kind: SpecContractType | PaidSpecContractType;
}

const SpecContractWrapper: FC<SpecContractWrapperProps> = ({
  kind,
  children,
}) => {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  return (
    <div className="w-full relative rounded-t-2xl overflow-hidden flex flex-col items-center">
      <SpecContractBg kind={kind} />
      <Close
        onClick={closeModal}
        className="absolute right-4 top-4 z-[9]"
        imageVariant="modal"
        variant="modal"
      />
      <H1 weight="bold" className="mt-8 relative z-[2]">
        {t(titles[kind])}
      </H1>
      {children}
    </div>
  );
};

export { SpecContractWrapper };
